import { SignUpProductEnum } from "components/Signup/flow/SignupFlow/types";
import { useSignupSelector } from "../hooks";
import { State } from "../state/types";
import { selectAnimalById } from "./animals";
import { isValidAnimal } from "components/Signup/steps/validations/animal";

export const selectCurrentInsuranceByAnimalId = (state: State, id?: string) => {
  if (!id) {
    throw new Error("No ID was provided");
  }

  const animal = selectAnimalById(state, id);

  if (!animal) {
    throw new Error(`No animal found for animal ${id}`);
  }

  return animal.insurances[0];
};

export const useCurrentInsuranceByAnimalId = (id: string) =>
  useSignupSelector((state) => selectCurrentInsuranceByAnimalId(state, id));

export const selectLiabilityInsuranceByAnimalId = (
  state: State,
  id?: string
) => {
  if (!id) {
    throw new Error("No ID was provided");
  }

  const animal = selectAnimalById(state, id);

  if (!animal) {
    throw new Error(`No animal found for animal ${id}`);
  }

  return animal.insurances.find(
    (insurance) => insurance.product === SignUpProductEnum.liability
  );
};

export const useLiabilityInsuranceByAnimalId = (id: string) =>
  useSignupSelector((state) => selectLiabilityInsuranceByAnimalId(state, id));

export const selectLiabilityNumberOfClaimsHistory = (state: State) => {
  const insurances = state.animals
    .filter(isValidAnimal)
    .flatMap((animal) => animal.insurances);

  return insurances.find(
    (insurance) => insurance.product === SignUpProductEnum.liability
  )?.liabilityNumberOfClaimsHistory;
};

export const selectLiabilityCancelledByPreviousCompany = (state: State) => {
  const insurances = state.animals
    .filter(isValidAnimal)
    .flatMap((animal) => animal.insurances);

  return insurances.find(
    (insurance) => insurance.product === SignUpProductEnum.liability
  )?.liabilityCancelledByPreviousInsuranceCompany;
};
